module.exports = new __parcel__URL__("kitten5.e9f78ddc.png").toString();